<p class="title">
  <img src="assets/images/edit.svg" alt="Image" class="icon-title" />
  {{ 'cliente-edit.texts.editar_cliente' | translate }}
</p>

<div class="container mt-1">
  <div id="mainDiv" class="main-div form-div">
    <div class="form-container formgrid grid">
      <div class="mb-3 col-12">
        <h3 class="mt-0 mb-2 font-bold text-lg">{{ 'cliente-edit.texts.dados_gerais' | translate }}</h3>
        <p-divider></p-divider>
      </div>

      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.tipo_pessoa' | translate }}</label>
        <p-dropdown id="tipoPessoa" [class.error-field]="!form.tipoPessoa" [options]="tipoPessoaOptions"
          [(ngModel)]="form.tipoPessoa" optionLabel="label"
          placeholder="{{ 'cliente-edit.placeholders.selecione_o_tipo_de_pessoa' | translate }}" appendTo="body"
          (onChange)="onTipoPessoaChange()"></p-dropdown>
      </div>
      <div class="field col-5 md:col-3" *ngIf="form.tipoPessoa?.value === 'JURIDICA'">
        <label>{{ 'cliente-edit.labels.ruc' | translate }}</label>
        <input type="text" pInputText [(ngModel)]="form.ruc"
          placeholder="{{ 'cliente-edit.placeholders.ruc_do_cliente' | translate }}" class="input-field" />
      </div>
      <div class="field col-5 md:col-3" *ngIf="form.tipoPessoa?.value === 'FISICA'">
        <label>{{ 'cliente-edit.labels.ci' | translate }}</label>
        <input type="text" pInputText
          [(ngModel)]="form.ci"
          placeholder="{{ 'cliente-edit.placeholders.ci' | translate }}" class="input-field"
          maxlength="8" inputmode="numeric" pattern="[0-9]*"
          (ngModelChange)="onCiModelChange($event)"
          (input)="onCiInput($event)" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.nome' | translate }} <span class="text-red-500">*</span></label>
        <input [class.error-field]="!form.nome" type="text" pInputText [(ngModel)]="form.nome"
          placeholder="{{ 'cliente-edit.placeholders.nome_do_cliente' | translate }}" class="input-field" />
      </div>
      <div class="field col-5 md:col-5">
        <app-phone-input
          [(telefone)]="form.telefone"
          [(ddi)]="paisSelecionado"
          [label]="('cliente-edit.labels.ddi' | translate) + ' / ' + ('cliente-edit.labels.telefone' | translate)"
          [placeholder]="'cliente-edit.placeholders.telefone' | translate"
          (telefoneInput)="applyMask($event)">
        </app-phone-input>
      </div>
      <div class="field col-12 flex align-items-center">
        <label class="mr-2 mb-0">{{ 'cliente-edit.labels.cliente' | translate }}:</label>
        <div class="flex items-center mr-2">
          <p-checkbox inputId="categoriaCliente" name="categoriaCliente" [(ngModel)]="form.categoriaCliente"
            binary="true" [disabled]="true" />
          <label for="categoriaCliente" class="ml-2"> {{ 'add-cliente.labels.cliente' | translate }} </label>
        </div>
        <div class="flex items-center">
          <p-checkbox inputId="categoriaFornecedor" name="categoriaFornecedor" [(ngModel)]="form.categoriaFornecedor"
            binary="true" />
          <label for="categoriaFornecedor" class="ml-2"> {{ 'cliente-edit.labels.provedor' | translate }} </label>
        </div>
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.nome_fantasia' | translate }}</label>
        <input type="text" pInputText [(ngModel)]="form.fantasia" [disabled]="isPessoaFisica()" class="input-field"
          [ngClass]="{'input-field-disabled': isPessoaFisica()}" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.data_de_nascimento' | translate }}</label>
        <input type="date" pInputText [(ngModel)]="form.dataNascimento"
          placeholder="{{ 'cliente-edit.placeholders.data_de_nascimento' | translate }}"
          max="9999-12-31" min="1900-01-01"
          (input)="onDateInput($event)"
          class="input-field" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.e_mail' | translate }}</label>
        <input type="email" pInputText [(ngModel)]="form.email"
          placeholder="{{ 'cliente-edit.placeholders.e_mail_do_cliente' | translate }}" class="input-field" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.sexo' | translate }} </label>
        <p-dropdown id="sexo" [class.error-field]="!form.sexo" [options]="sexoOptions" [(ngModel)]="form.sexo"
          optionLabel="label" placeholder="{{ 'cliente-edit.placeholders.selecione_o_sexo' | translate }}" appendTo="body"></p-dropdown>
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.tipo_natureza_fiscal' | translate }} </label>
        <p-dropdown id="tipoNaturezaFiscal" [class.error-field]="!form.tipoNaturezaFiscal"
          [options]="tipoNaturezaFiscalOptions" [(ngModel)]="form.tipoNaturezaFiscal" optionLabel="label"
          placeholder="{{ 'cliente-edit.placeholders.selecione_o_tipo_de_natureza_fiscal' | translate }}" appendTo="body"></p-dropdown>
      </div>

      <div class="mb-3 col-12">
        <h3 class="mt-0 mb-2 font-bold text-lg">{{ 'cliente-edit.texts.endereco' | translate }}</h3>
        <p-divider></p-divider>
      </div>

      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.cidade' | translate }}</label>
        <p-dropdown id="selecionarCidade" [options]="cidadeList" [(ngModel)]="form.cidade" optionLabel="label"
          placeholder="{{ form.cidade?.label }}" [filter]="true" filterBy="label" [showClear]="true"
          (onChange)="onSelecionarCidade($event)" appendTo="body" panelStyleClass="ddi-dropdown-panel-erp"
          scrollHeight="340px"></p-dropdown>
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.estado' | translate }}</label>
        <input type="text" pInputText class="input-field input-field-disabled" [disabled]="true"
          [(ngModel)]="estadoCidade" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.endereco' | translate }}</label>
        <input type="text" pInputText [(ngModel)]="form.endereco"
          placeholder="{{ 'cliente-edit.placeholders.endereco_do_cliente' | translate }}" class="input-field" />
      </div>
      <div class="field col-6 md:col-4">
        <label>{{ 'cliente-edit.labels.numero' | translate }}</label>
        <input type="text" pInputText [(ngModel)]="form.numero"
          placeholder="{{ 'cliente-edit.placeholders.numero_do_endereco' | translate }}" class="input-field" />
      </div>
      <div class="actions-container">
        <button pButton label="{{ 'cliente-edit.botoes.voltar' | translate }}" (click)="navigateListaDeClientes()"
          severity="secondary" icon="pi pi-arrow-left" class="btn-secondary"></button>
        <button pButton label="{{ 'cliente-edit.botoes.atualizar' | translate }}" icon="pi pi-check"
          (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary"></button>
      </div>
    </div>
  </div>
  <p-toast />
</div>